import React, { CSSProperties } from 'react';
import { useRecoilValue } from 'recoil';
import { CompleteTheLookQuickBuy } from './CompleteTheLookQuickBuy';
import { ProductHandle } from '../enums/ProductHandle.enum';
import { CompleteTheLookTag } from '../enums/ProductTag.enum';
import { SelectionType } from '../enums/SelectionType.enum';
import { ViewProduct } from '../models/ViewProduct.model';
import { isDesktopState, productsState } from '../recoil/selectors';
import styles from './CompleteTheLook.module.scss';
import { useProductSelection } from '../hooks/useProductSelection';
import { environmentContextState } from '../recoil/atoms';

interface Props {
  product: ViewProduct;
  selectionType: SelectionType;
  style?: CSSProperties;
  Wrapper?: React.FC;
}

export const CompleteTheLook: React.FC<Props> = ({ product, style, selectionType, Wrapper }) => {
  const { size, color } = useProductSelection(selectionType, '0');
  const allProducts = useRecoilValue(productsState);
  const { timedSaleActive } = useRecoilValue(environmentContextState);
  const completeTheLookTags = product.tags.filter((t) => t.startsWith('set-')) as CompleteTheLookTag[];
  const completeTheLookHandles = completeTheLookTags.map((t) => t.substring(4, t.length)) as ProductHandle[];
  const isDesktop = useRecoilValue(isDesktopState);
  const MAX_PROMOS = isDesktop ? 5 : 3;

  if (!color) return <></>;

  const ctlPromos = completeTheLookHandles.reduce((acc, handle, i) => {
    const targetProduct = allProducts[handle];
    const colorAvailable = targetProduct?.colors.includes(color);

    if (acc.length >= MAX_PROMOS) return acc;

    if (colorAvailable) {
      return [...acc, <CompleteTheLookQuickBuy key={i} selectionKey={`ctl-${i}-${handle}`} product={allProducts[handle]} initialSize={size} color={color} />];
    }

    return acc;
  }, [] as JSX.Element[]);

  if (ctlPromos.length === 0) return <></>;

  const discountPercent = timedSaleActive ? 10 : 20;

  const content = (
    <div className={styles.container} style={style}>
      <span className={styles.title}>
        CUSTOMERS ALSO BOUGHT
        <br />({`${discountPercent}`}% OFF SECOND ITEM)
      </span>
      {ctlPromos.map((promo) => promo)}
    </div>
  );

  return Wrapper ? <Wrapper>{content}</Wrapper> : content;
};

export default CompleteTheLook;
